/// <amd-module name="Artifacts/Nuget/commands/Promote" />

import { NugetActions } from "Artifacts/Nuget/redux";
import { getPromoteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPromoteCommand = getPromoteCommandCreator(NugetActions.promote);
